module.exports = __webpack_public_path__ + "img/label.88f30ed7.png";